import { render, staticRenderFns } from "./ActionListWaitApproveMessage.vue?vue&type=template&id=fa951cfe&"
import script from "./ActionListWaitApproveMessage.vue?vue&type=script&lang=ts&"
export * from "./ActionListWaitApproveMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports